import { Slider } from "hardcover-ui/components/Slider";
import { secondsFormat } from "lib/bookUtils";
import { useEffect, useState } from "react";

function writeProgressMessage(
  readingFormatId: number,
  progressNumber: number,
  progressMax: number
) {
  const percentComplete = Math.round((progressNumber / progressMax) * 100);
  if (readingFormatId === 2) {
    return (
      secondsFormat(progressNumber) +
      " of " +
      secondsFormat(progressMax) +
      " (" +
      percentComplete +
      "%)"
    );
  }
  return `Page ${progressNumber.toLocaleString()} of ${progressMax.toLocaleString()} (${percentComplete}%)`;
}

interface Props {
  progressNumber: number | null;
  progressMax: number | null;
  onChange: (progress: number) => void;
  readingFormatId: number;
}
export default function ProgressSlider({
  progressNumber = 0,
  progressMax,
  onChange,
  readingFormatId,
}: Props) {
  const [progress, setProgress] = useState(progressNumber || 0);

  useEffect(() => {
    setProgress(progressNumber || 0);
  }, [progressNumber]);

  const onProgressChange = (newProgress: number) => {
    setProgress(newProgress);
    onChange(newProgress);
  };

  if (!progressMax) {
    return false;
  }

  const message = writeProgressMessage(readingFormatId, progress, progressMax);

  return (
    <div className="relative">
      <Slider
        value={[progress]}
        onValueChange={
          onChange ? (newValues) => onProgressChange(newValues[0]) : null
        }
        max={progressMax}
        step={1}
        data-tooltip-id="tooltip"
        data-tooltip-content={message}
      />
      {progressNumber !== progress ? (
        <p className="md:hidden mt-4 rounded-sm bg-gray-200 dark:bg-gray-900 p-2">
          <b>Changing to...</b> {message}
        </p>
      ) : (
        false
      )}
    </div>
  );
}
